import { Input, Button } from "@renderbus/ui";
import styled from "styled-components";

export function ValidateCodeItem({
  value,
  onChange,
  codePlaceholder,
  sendCode,
  sendCodeDisable,
  countDown,
  sending,
  sendCodeText,
}: {
  value?: string;
  onChange?: (v: string) => void;
  codePlaceholder?: string;
  sendCode?: () => void;
  sendVoiceCode?: () => void;
  sendCodeDisable?: boolean;
  countDown?: number;
  sending?: boolean;
  sendCodeText?: string;
}) {
  return (
    <>
      <Wrapper>
        <Input
          size="large"
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          placeholder={codePlaceholder}
        />
        <SendCodeButton
          ghost
          size={"large"}
          onClick={sendCode}
          disabled={sendCodeDisable}
          loading={sending}
        >
          {countDown ? `${countDown}s` : sendCodeText}
        </SendCodeButton>
      </Wrapper>
    </>
  );
}

const Wrapper = styled.div`
  display: flex;
  gap: 16px;
`;

const SendCodeButton = styled(Button)`
  flex-shrink: 0;
  min-width: 104px;
`;
